import { Component, OnInit, ChangeDetectorRef  } from '@angular/core';

import { Circular,CircularNotification } from 'src/app/shared/models/circular.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { WorkspaceService } from 'src/app//shared/services/workspace.service';


@Component({
  selector: 'app-circular-tasks-directory-decision',
  templateUrl: './Circular-tasks-directory-compnent.html'
})

export class CircularTasksDirectoryComponent implements OnInit {
  public currentUser: User = new User();
  public circulars: CircularNotification[] = [];
  myNotifications: number;
  private ob : CircularNotification[] = [];
  user = new User();
  IsAdmin: boolean;
  constructor(private workspaceService: WorkspaceService, private lookupService: LookupService, private globalServices: GlobalServices, private cd: ChangeDetectorRef, private router: Router, private authenticationService: AuthenticationService) {
    this.user = this.authenticationService.currentUserValue;
    this.IsAdmin = this.user.IsAdmin;
    if (!this.IsAdmin) {
      this.router.navigate(['/unAuhtorized']);
    }
  }
  ngOnInit() {
    this.globalServices.IsLoaderEnabled = true;
    this.loadCirculars();
    setInterval(() => { this.loadCirculars(); }, 30000);
  }
  getUserNotificationsCounts(Circularid:number) {
      this.workspaceService.GetCircularDirectoryNotifications(this.user.UserName, this.user.UserId == undefined ? "00000000-0000-0000-0000-000000000000" : this.user.UserId, this.IsAdmin,Circularid).subscribe(
        data => this.myNotifications = data.Data.CircularsPendingTasksCount,
        () => console.log('Something went wrong!!'),
        () => this.loadNotificationsCompleted(this.myNotifications,Circularid)
      );
    
  }

  loadNotificationsCompleted(myNotifications : number, id : number){

   let newitem = this.circulars.find(i => i.Id ==id);
   newitem.NotificationCount = myNotifications;
   let index = this.circulars.indexOf(newitem);
   this.circulars[index] = newitem;

    
  }
  loadCircularsCompleted() {
    this.circulars.forEach((key) => {
      this.getUserNotificationsCounts(key.Id);
    });
    this.globalServices.IsLoaderEnabled = false;
  }
  loadCirculars(): void {
    if (window.location.hash.toLowerCase().indexOf("circularstasksdirectory") > -1) {
      this.lookupService.getCirculars().subscribe(
      data => this.circulars = data.Data as CircularNotification[],
      () => console.log("Something went wrong!!"),
      () => this.loadCircularsCompleted()
    );
    }
    
  }
  goToCircularTaks(id) {
    this.router.navigate(['/CircularsTasks', { Id: id }]);
  }
}

